import { canRead, canWrite } from '../access/rbacAccess'

export const USERS_APP = {
  LIST: 'planifica.users_app',
  REFUND_LIMITS_TAB: 'planifica.users.show.refund_limits_tab'
}

export const canViewUsersApp = () => canRead(USERS_APP.LIST)

export const canManageUsersApp = () => canWrite(USERS_APP.LIST)

export const canViewUserRefundLimitsTab = () => canRead(USERS_APP.REFUND_LIMITS_TAB)

export const canManageUserRefundLimitsTab = () => canWrite(USERS_APP.REFUND_LIMITS_TAB)
